module.exports = __webpack_public_path__ + "static/media/web-removebg-preview.0349d32a.png";